module.exports = __webpack_public_path__ + "img/22-1.d153b32a.png";